import { ValidationUtil } from '@app/common/util/validation.util';
import { environment } from '@enviroments/environment';
import { CompanyConstant } from '../constant/company.constant';
import { LangConstant } from '../constant/lang.constant';
import { AuthUtil } from './auth.util';
import { ConvertUtil } from './convert.util';
import { CommonConstant } from '../constant/common.constant';
import { Router } from '@angular/router';
import { MemberConstants } from '../constant/member.constant';
import { Member } from '@app/models/myoffice/member/member.model';

export class CommonUtils {

  static getMessages(): string {
    return 'messages.' + CommonUtils.getLangMessage();
  }

  static getLangMessage(): string {
    let res = environment.default_lang.toLowerCase();
    let lang = CommonUtils.getLang();

    switch (lang) {
      case 'kr':
        res = 'kr';
        break;
      case 'en':
        res = 'en';
        break;
      case 'us':
        res = 'en';
        break;
      default:
        res = 'en';
        break;
    }

    return res;
  }

  static getLang(): string {
    let loginedInfo = AuthUtil.getLoginedInfo();
    let lang = sessionStorage.getItem(LangConstant.STR_LANG);

    if (ValidationUtil.isNullOrEmpty(lang)) {
      if (loginedInfo) {
        lang = ConvertUtil.convertToSring(loginedInfo.ctrCd);
      } else {
        lang = 'kr';
      }
      sessionStorage.setItem(LangConstant.STR_LANG, lang);
    }


    return ConvertUtil.convertToSring(lang).toLowerCase();
  }

  static getYN(value: string) {
    return (value === null || value === CommonConstant.NO || value === undefined || value.length <= 0) ? false : true;
  }

  // static isCompanyUS(){
  //   return CompanyConstant.COM_ID_MEDIUS == environment.comId //TODO
  // }
  // static isLangUS(){
  //   return (CommonUtils.getLang() == 'en' || CommonUtils.getLang() == 'EN');
  // }

  /**
 * Kiểm tra xem các bước trước đã hoàn thành chưa, sau đó chuyển bước nếu hợp lệ.
 * @param currentStep Số bước hiện tại
 * @param router Angular Router
 * @param step Số bước muốn đi đến
 * @returns true nếu chuyển thành công, false nếu bị chặn
 */
  static goToStepIfAllowed(
    currentStep: number,
    router: Router,
    step: number,

  ): boolean {
    const baseUrl: string = '/my-office/member-management/member-regis-'
    for(let i = currentStep; i < step ; i ++){
      const currentKey = MemberConstants.STR_IS_DONE_STEP_PREFIX + i;
      window.sessionStorage.setItem(currentKey, 'true');
    }
    router.navigateByUrl(`${baseUrl}${step}`);
    return true;
  }



  /**
   * Hàm kiểm tra quyền truy cập vào bước hiện tại. Nếu chưa đủ điều kiện sẽ redirect ngược.
   * @param currentStep Bước hiện tại (VD: 3)
   * @param router Angular Router
   */
  static checkStepAccess(
    currentStep: number,
    router: Router
  ): void {
    const baseUrl: string = '/my-office/member-management/member-regis-'
    for (let i = 1; i < currentStep; i++) {

      const key = MemberConstants.STR_IS_DONE_STEP_PREFIX + i;
      const isDone = window.sessionStorage.getItem(key);
      if (isDone !== 'true') {
        // Redirect ngược lại bước chưa hoàn thành
        router.navigateByUrl(`${baseUrl}${i}`);
        return;
      }
    }
  }

  static isLinkOrderUser() : boolean
  {
    const userid = sessionStorage.getItem("userid_link_order");
    if(ValidationUtil.isNotNullAndNotEmpty(userid))
    {
      return true;
    }
    return false;

  }

  static generateDeviceId(length: number = 25): string {
    const chars: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result: string = '';
    
    for (let i: number = 0; i < length; i++) {
        const randomIndex: number = Math.floor(Math.random() * chars.length);
        result += chars.charAt(randomIndex);
    }
    
    return result;
  }

  static getInfoMemberOrderLink(): Member | null {
    let str = sessionStorage.getItem("infoMemberOrderLink");
    if (ValidationUtil.isNotNullAndNotEmpty(str)) {
      return JSON.parse(str + "");
    }
    return null;
  }

  static getSessionUserLinkOrder() : any {
    return sessionStorage.getItem("userid_link_order")
  }

  static getLoginIdNotExist() : string []{
    return [
      "login" , "shopping-mall" , "my-office" , "report" 
    ]
  }

}

